import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

export type ClassRoutine = {
  _id: string
  teacher: any
  branch: any
  session: any
  class: any
  section: any
  course: any
  dayOfWeek: string
  startTime: string
  endTime: string
  room: string
  isActive: boolean
  isDeleted?: boolean
  createdBy: string
  updatedBy: string
  createdAt: string
  updatedAt: string
  term?: string
  system?: any
}

export type ClassRoutineCreateData = {
  teacher: string
  branch: string
  session: string
  class: string
  section: string
  course: string
  dayOfWeek: string
  startTime: string
  endTime: string
  room?: string
  term?: string
  isActive?: boolean
  system?: string
  teacherName?: string
}

export type ClassRoutineUpdateData = Partial<ClassRoutineCreateData>

export type PaginationData = {
  currentPage: number
  hasNextPage: boolean
  hasPrevPage: boolean
  limit: number
  total: number
  totalPages: number
}

export type ClassRoutineResponse = {
  message: string
  data: ClassRoutine
}

export type ClassRoutineListResponse = {
  data: ClassRoutine[]
  pagination: PaginationData
}

export type TeacherTimetableResponse = {
  data: (ClassRoutine & {
    breakTime?: {
      startTime: string;
      endTime: string;
    } | null;
  })[];
}

const CLASS_ROUTINE_ENDPOINT = {
  CLASS_ROUTINES: "/class-routine"
}

const createClassRoutine = async (data: ClassRoutineCreateData): Promise<ClassRoutineResponse> => {
  const response = await apiClient({
    url: `${CLASS_ROUTINE_ENDPOINT.CLASS_ROUTINES}/create`,
    method: "POST",
    data,
  })
  return response.data
}

const getAllClassRoutines = async ({
  page = 1,
  limit = 10,
  sortBy,
  sortOrder,
  system,
  searchText: search,
  teacher,
  class: classId,
  section,
  course,
  dayOfWeek,
  room,
  term,
  session,
}: {
  page?: number
  limit?: number
  sortBy?: string
  sortOrder?: string
  teacher?: string
  class?: string
  searchText?: string
  section?: string
  system?: string
  course?: string
  dayOfWeek?: string
  room?: string
  term?: string
  session?:string
} = {}): Promise<ClassRoutineListResponse> => {
  const response = await apiClient({
    url: appendQueryParams(CLASS_ROUTINE_ENDPOINT.CLASS_ROUTINES, {
      page,
      limit,
      sortBy,
      sortOrder,
      teacher,
      class: classId,
      section,
      system,
      course,
      searchText: search,
      dayOfWeek,
      room,
      term,
      session
    }),
    method: "GET",
  })
  return response.data
}

const getClassRoutineById = async (id: string): Promise<{ data: ClassRoutine }> => {
  const response = await apiClient({
    url: `${CLASS_ROUTINE_ENDPOINT.CLASS_ROUTINES}/${id}`,
    method: "GET",
  })
  return response.data
}

const updateClassRoutine = async (
  id: string,
  data: ClassRoutineUpdateData
): Promise<ClassRoutineResponse> => {
  const response = await apiClient({
    url: `${CLASS_ROUTINE_ENDPOINT.CLASS_ROUTINES}/update/${id}`,
    method: "PUT",
    data,
  })
  return response.data
}

const deleteClassRoutine = async (id: string): Promise<{ message: string; data: ClassRoutine }> => {
  const response = await apiClient({
    url: `${CLASS_ROUTINE_ENDPOINT.CLASS_ROUTINES}/delete/${id}`,
    method: "DELETE",
  })
  return response.data
}

const getTeacherTimetable = async (
  teacherId: string,
  params?: {
    termId?: string;
    classId?: string;
  }
): Promise<TeacherTimetableResponse> => {
  const response = await apiClient({
    url: (`${CLASS_ROUTINE_ENDPOINT.CLASS_ROUTINES}/teacher/${teacherId}`),
    method: "GET",
  });
  return response.data;
};

export {
  createClassRoutine,
  getAllClassRoutines,
  getClassRoutineById,
  updateClassRoutine,
  deleteClassRoutine,
  getTeacherTimetable,
}